import { isNil } from 'ramda'
import { useEffect } from 'react'

import { User } from '~/hooks/useAuthentication/types'

import { CustomerType } from '~/__generated_types__/globalTypes'

const COMPANY_DOMAINS = ['@ryder.com', '@baton.io'] as const

const isExternalUser = (email: string): boolean => {
  return !COMPANY_DOMAINS.some((domain) => email.endsWith(domain))
}

const useMedalliaSetup = (user: User | null | undefined) => {
  useEffect(() => {
    if (isNil(user?.customer) || isNil(user)) return

    try {
      const email = user.email
      const medaliaSetting = {
        customer: user.customer.name || 'N/A',
        email: user.email,
        sourceTM: user.customer.type === CustomerType.Tm ? 'ROL' : 'TMW/SCOS',
        isExternal: isExternalUser(email) ? 'true' : 'false',
        isVisibilityDashboardClicked: true,
      }

      Object.assign(window, medaliaSetting)
    } catch (error) {
      console.error('Failed to configure Medallia settings:', error)
    }
  }, [user])
}

export default useMedalliaSetup
